import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Circle.es.js";
const o = e.forwardRef((r, c) => /* @__PURE__ */ e.createElement(t, { ref: c, ...r, weights: a }));
o.displayName = "CircleIcon";
const s = o;
export {
  s as Circle,
  o as CircleIcon
};
